<template>
  <div>
    <section>
      <ul
        class="overall-menu"
        v-if="showHamBurgerIcon===false || (showHamBurgerIcon===true && changeToMobileScreen === false)"
      >
        <li class="sub-menu-parent" tab-index="0">
        <router-link to="/home">
            <img src="../assets/home.png" class="imghome" />
          </router-link>
      </li>
      <li class="sub-menu-parent" tab-index="0" v-for="(menuItem, i) in menuItems" v-bind:key="i">
          <a v-if="menuItem.componentName == null && menuItem.type != 'action'" href="#">{{menuItem.name}}</a>

          <!-- <router-link v-if="menuItem.componentName == 'home'" :to="'/'+menuItem.componentName">
            <img src="../assets/home.png" class="imghome" />
          </router-link> -->
          <router-link
            v-else-if="menuItem.componentName != null && menuItem.componentName !== 'home' && menuItem.type != 'action'"
            :to="'/'+menuItem.componentName"
            tag="a"
          >{{menuItem.name}}</router-link>

          <ul class="sub-menu" v-if="menuItem.subMenu.length > 0">
            <li class="sub-menu-parent" v-for="(menuSubitem, j) in menuItem.subMenu" v-bind:key="j">
              <a v-if="menuSubitem.componentName == null && menuSubitem.type != 'action'" class="submenuitem" href="#">{{menuSubitem.name}}</a>
              <router-link
                v-if="menuSubitem.componentName != null && menuSubitem.type != 'action'"
                :to="'/'+menuSubitem.componentName"
                tag="a"
                class="submenuitem"
              >{{menuSubitem.name}}</router-link>

              <ul class="sub-sub-menu" v-if="menuSubitem.subMenu.length > 0">
                <li v-for="(subMenuSubitem, k) in menuSubitem.subMenu" v-bind:key="k">
                  <a v-if="subMenuSubitem.componentName == null && subMenuSubitem.type != 'action'" class="submenuitem" href="#">{{subMenuSubitem.name}}</a>
                  <router-link
                    v-if="subMenuSubitem.componentName != null && subMenuSubitem.type != 'action'"
                    :to="'/'+subMenuSubitem.componentName"
                    tag="a"
                    class="submenuitem"
                  >{{subMenuSubitem.name}}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <div class="sub-menu-parent">
        <div
          v-bind:class="{ containerburger: showHamBurgerIcon===true}"
          v-on:click="showHamBurgerIcon = !showHamBurgerIcon"
        >
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

export default {

  data () {
    return {
      menuItems: JSON.parse(localStorage.getItem('userPermissions')),
      // menuItems: [
      //   { name: 'Home', id: 'home', componentName: 'home', childMenus: [] },

      //   { name: 'Manage Employees', id: 'manageEmployee', componentName: '', childMenus: [ { name: 'Add Employee', id: 'addEmployee', componentName: 'addEmployee', childMenus: [] }, { name: 'View/Update Employee', id: 'viewUpdateEmployee', componentName: 'viewUpdateEmployee', childMenus: [] }] },

      //   { name: 'Manage Customers', id: 'manageCustomer', componentName: '', childMenus: [ { name: 'Add Customer', id: 'addCustomer', componentName: 'addCustomer', childMenus: [] }, { name: 'View/Update Customer', id: 'viewUpdateCustomer', componentName: 'viewUpdateCustomer', childMenus: [] },{ name: 'Merge Customer', id: 'mergeCustomerData', componentName: 'mergeCustomerData', childMenus: [] }] },

      //   // { name: 'Manage Customers', id: 'manageCustomer', componentName: '', childMenus: [ { name: 'Add Customer', id: 'addCustomer', componentName: 'addCustomer', childMenus: [] }, { name: 'View/Update Customer', id: 'viewUpdateCustomer', componentName: 'viewUpdateCustomer', childMenus: [] }] },
      //   { name: 'Manage Sources', id: 'manageSource', componentName: '', childMenus: [ { name: 'Add Dealer', id: 'addDealer', componentName: 'AddDealer', childMenus: [] }, { name: 'View/Update Dealer', id: 'viewUpdateDealer', componentName: 'viewUpdateDealer', childMenus: [] }, { name: 'Manage Inhouse', id: 'manageInhouse', componentName: 'manageInhouse', childMenus: [] },{ name: 'Merge Dealer', id: 'mergeDealerData', componentName: 'mergeDealerData', childMenus: [] }] },
      //   // { name: 'Manage Sources', id: 'manageSource', componentName: '', childMenus: [ { name: 'Add Dealer', id: 'addDealer', componentName: 'AddDealer', childMenus: [] }, { name: 'View/Update Dealer', id: 'viewUpdateDealer', componentName: 'viewUpdateDealer', childMenus: [] }, { name: 'Manage Inhouse', id: 'manageInhouse', componentName: 'manageInhouse', childMenus: [] }] },
        
      //   // { name: 'Activity Tracking',id:'activityTracking',componentName:'', childMenus:[ {name:'Schedule Activity',id:'scheduleActivity',componentName:'scheduleActivity', childMenus:[]},{name:'View Activity',id:'viewActivity',componentName:'viewActivity', childMenus:[]},{name:'Manage Mileage',id:'manageMileage',componentName:'manageMileage', childMenus:[]},{name:'Add Task',id:'addTask',componentName:'addTask', childMenus:[]},{name:'Update Task',id:'updateTask',componentName:'updateTask', childMenus:[]},{name:'View Task',id:'viewTask',componentName:'viewTask', childMenus:[]}]  },
      //   { name: 'Activity Tracking', id: 'activityTracking', componentName: '', childMenus: [ { name: 'Schedule Activity', id: 'scheduleActivity', componentName: 'scheduleActivity', childMenus: [] }, { name: 'Manage Mileage', id: 'manageMileage', componentName: 'manageMileage', childMenus: [] }, { name: 'Add Task', id: 'addTask', componentName: 'addTask', childMenus: [] }, { name: 'Update Task', id: 'updateTask', componentName: 'updateTask', childMenus: [] }, { name: 'View Task', id: 'viewTask', componentName: 'viewTask', childMenus: [] }] },

      //   { name: 'Performance Tracking', id: 'performanceTracking', componentName: '', childMenus: [ { name: 'View Dashboard', id: 'viewDashBoard', componentName: 'ViewDashBoard', childMenus: [] }, { name: 'View Scorecard', id: 'viewScorecard', componentName: 'viewScorecard', childMenus: [] }, { name: 'View Assignments', id: 'viewAssignments', componentName: 'viewAssignments', childMenus: [] }, { name: 'Dashboard Reporting', id: 'dashboard', componentName: 'dashboard', childMenus: [] }] },

      //   { name: 'Deals Tracking', id: 'dealsTracking', componentName: '', childMenus: [ { name: 'Generate Quote', id: 'generateQuote', componentName: 'generateQuote', childMenus: [] }, { name: 'Edit Quote', id: 'editQuote', componentName: 'editQuote', childMenus: [] }, { name: 'Add Application', id: 'addApplication', componentName: 'addApplication', childMenus: [] }, { name: 'Review Application', id: 'reviewApplication', componentName: 'reviewApplication', childMenus: [] }, { name: 'Convert App to Deal', id: 'convertAppToDeal', componentName: 'convertAppToDeal', childMenus: [] }, { name: 'View Deals ', id: 'viewDeals', componentName: 'viewDeals', childMenus: [] }, { name: 'Yodlee', id: 'help', componentName: 'yodlee', childMenus: [] },{name: 'Manage VIN', id: 'ManageVin', componentName: '', childMenus: [
      //   {name: 'Add Vin', id: 'AddVin', componentName: 'addVin', childMenus: []},
      //   {name: 'Blacklist Vin', id: 'VinBlacklist', componentName: 'vinBlacklist', childMenus: []}
      //   ]}] },

      //   { name: 'Reporting', id: 'reporting', componentName: '', childMenus: [ { name: 'Salesperson Task Notes', id: 'viewAgentTaskNotes', componentName: 'ViewAgentTaskNotes', childMenus: [] }, { name: 'Report an Issue', id: 'reportissue', componentName: 'ReportIssue', childMenus: [] }, { name: 'Data Report', id: 'datareport', componentName: 'DataReport', childMenus: [] }, { name: 'Automated Quote Tool', id: 'collateralprice', componentName: 'collateralPrice', childMenus: [] }, { name: 'Payoff Quote', id: 'payoff', componentName: 'PayOff', childMenus: [] }, { name: 'Customer Audit History', id: 'fraudAuditHistory', componentName: 'CustomerFraudHistory', childMenus: [] },

      //       { 
      //         name: 'Sales & Property Tax', 
      //         id: 'salesPropertyTax', 
      //         componentName: 'salesPropertyTax', 
      //         childMenus: [] 
      //       }
      //   ] 
      //   },

      //   { name: 'Customer Universal Search', id: 'customerUniversalSearch', componentName: 'CustomerUniversalSearch', childMenus: [] },

      //   { name: 'Dmv Title', id: 'dmvTitle', componentName: 'DMVTitle', childMenus: [] },

      //   { name: 'Resource', id: 'resource', componentName: '', childMenus: [ { name: 'Release Notes', id: 'releaseNotes', componentName: '', componentType: 'pdf', childMenus: [] }, { name: 'User Manual', id: 'userManual', componentName: '', componentType: 'xlsx', childMenus: [] }, { name: 'Help', id: 'help', componentName: 'llpHelp', childMenus: [] }, { name: 'Contact', id: 'contact', componentName: 'Contact', childMenus: [] }] },

      //   // { name: 'Role Management', id: 'roleManagement', componentName: 'RoleManagement', childMenus: [] },
      // ],
      showHamBurgerIcon: true,
      changeToMobileScreen: false
    }
  },
  methods: {
    isMobileScreeen () {
      setInterval(() => {
        var w = window.innerWidth
        if (w < 1100) {
          this.changeToMobileScreen = true
        } else {
          this.changeToMobileScreen = false
        }
      }, 100)
    }

  },
  mounted () {
    this.isMobileScreeen()
  },
  computed: {

  }
}
</script>
<style scoped>
.sub-menu{
  box-shadow: 0 15px 20px rgba(0,0,0,0.12);
}
  .sub-menu-parent .sub-menu-parent .sub-sub-menu {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: 100%;
    width: 150px;
    background-color: #fff;
    box-shadow: 0 15px 20px rgba(0,0,0,0.12);
    top: 0;
    z-index: 1;
    transform: translateY(-2em);
    transition-delay: 0s, 0s, 0.3s; 
}
.sub-menu-parent .sub-menu-parent:hover .sub-sub-menu {
  top: 0;
  visibility: visible;
  opacity: 1;
  transform: translateY(0%);
}
</style>
